import { DatePicker } from '@mui/x-date-pickers-pro';
import {Controller, useFormContext} from "react-hook-form";
import {useTranslation} from "react-i18next";
import moment, { Moment } from 'moment'
import 'moment/locale/ru';
import {SUPPLIER_FORM, SupplierForm} from "../index";

const DateInputSupplier  = () => {

  const { t } = useTranslation()

  const { control } = useFormContext<SupplierForm>()

  return (
    <Controller
      name={SUPPLIER_FORM.CONTRACT_DATE}
      control={control}
      render={({ field, fieldState }) => (
        <DatePicker
          label={t('calc__text__main__contractDateNotRequired')}
          value={field.value ? moment(field.value, 'YYYY-MM-DD') : null}
          disableFuture
          onChange={(value: Moment | null) => {
            field.onChange(value ? moment(value).format('YYYY-MM-DD') : '');
          }}
          sx={{
            '.MuiPickersOutlinedInput-root': {
              borderRadius: 0,
            }
          }}
          slotProps={{
            textField: {
              error: !!fieldState.error,
              helperText: fieldState.error?.message ?? '',
              InputLabelProps: { shrink: true },
            },
          }}
        />
      )}
    />


  )
}

export default DateInputSupplier
